import TextField from '@mui/material/TextField';
import React, { useState } from 'react';

import ConfirmDialog from 'ui/modules/dialogs/ConfirmDialog';
import Button from 'ui/elements/buttons/Button';

interface Props {
  isDialogOpen: boolean;
  closeDialog: () => void;
  onConfirm: (embedUrl: string) => void;
}

export default function EmbedDialog(props: Props) {
  const [embedUrl, setEmbedUrl] = useState('');
  return (
    <ConfirmDialog
      maxWidth="sm"
      title="Embed external content"
      isOpen={props.isDialogOpen}
      onClose={props.closeDialog}
      dismissLabel="Cancel"
      confirmButton={
        <Button kind="primary" onClick={() => props.onConfirm(embedUrl)}>
          Insert
        </Button>
      }
    >
      <p className="u-content-spacing-bottom">
        We currently support LinkedIn, Facebook, Instagram, Twitter, YouTube and Vimeo embeds.
      </p>
      <TextField
        fullWidth
        onChange={e => setEmbedUrl(e.target.value)}
        autoFocus
        placeholder="Enter embed url"
        multiline
        minRows={3}
        maxRows={12}
      />
    </ConfirmDialog>
  );
}
